import React from "react";
import { motion } from "framer-motion";
import toys from './quality-toys.png';

const fadeInLeft = {
  initial: { opacity: 0, x: -60 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.8 }
};

const fadeInRight = {
  initial: { opacity: 0, x: 60 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.8, delay: 0.2 }
};

function QualitySection() {
  const features = [
    {
      icon: "⭐",
      title: "Quality Guaranteed",
      description: "Every toy is crafted with care using child-safe, non-toxic materials to ensure your baby’s safety and happiness."
    },
    {
      icon: "✅",
      title: "Secure Payment",
      description: "Shop confidently with our 100% secure payment system protecting your personal and financial information."
    },
    {
      icon: "📦",
      title: "Easy Return",
      description: "Not satisfied? No worries — enjoy hassle-free returns and exchanges within 7 days of delivery."
    }
  ];

  return (
    <section
      className="flex justify-between items-stretch ms-10 my-10  overflow-hidden max-md:flex-col max-md:gap-0 max-md:text-center max-sm:mx-4"
      aria-labelledby="quality-heading"
    >
      <motion.div
        className="flex-1 px-10 py-20 max-md:px-6 max-md:py-16 max-sm:px-4 max-sm:py-10"
        variants={fadeInLeft}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
      >
        <header>
          <p className="mb-5 text-base font-semibold tracking-widest leading-6 text-[#04CA60] uppercase">
            Good Quality Guaranteed
          </p>
          <h2
            id="quality-heading"
            className="mb-10 text-5xl font-bold text-[#002347] leading-[50px] max-md:text-4xl max-md:leading-10 max-sm:text-3xl max-sm:leading-9"
          >
            We Offer You Top Quality, Baby toys
          </h2>
        </header>

        <div className="flex flex-col gap-6">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="flex gap-4 items-start"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <div className="shrink-0 w-10 h-10 text-xl bg-white rounded-full flex items-center justify-center">
                {feature.icon}
              </div>
              <div className="flex-1">
                <h3 className="mb-2 text-lg font-semibold leading-6 text-[#545454]">
                  {feature.title}
                </h3>
                <p className="text-sm leading-5 text-[#777777]">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        className="flex-1 flex items-stretch max-md:min-h-[300px]"
        variants={fadeInRight}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
      >
        <img
          src="https://cdn.acsdev.in/Rentastic/quality-toys.png"
          alt="Quality toys display"
          className="w-full h-full object-cover 
             rounded-l-3xl 
             rounded-tr-none rounded-br-none 
             max-md:rounded-none "
        />
      </motion.div>
    </section>
  );
}

export default QualitySection;
